import { createContext } from "react";
import type { CurrentWorkspace, User } from "../AuthProvider";

export type AuthorizedUserContextType = {
  currentUser: User;
  currentWorkspace: CurrentWorkspace;
};

export const AuthorizedUserContext = createContext<
  AuthorizedUserContextType | undefined
>(undefined);
